document.addEventListener("DOMContentLoaded", () => {
  const quantityUpsellEls = document.querySelectorAll(
    ".quantity-upsell [data-quantity]"
  );

  quantityUpsellEls.forEach((quantityUpsell) => {
    quantityUpsell.addEventListener("click", (event) => {
      const quantity = event?.target?.dataset?.quantity;
      const quantityEl = document.querySelector(
        '[action*="cart/add"] [name="quantity"]'
      );

      if (quantity && quantityEl) {
        quantityEl.value = quantity;
        quantityEl.dispatchEvent(new Event("input"));
      }

      const atc = document.querySelector(
        '#teeAtcButton, [action*="cart/add"] [type="submit"]'
      );

      if (atc) {
        atc.scrollIntoView({ behavior: "smooth", block: "end" });
        setTimeout(() => {
          atc.click();
        }, 200);
      }
    });
  });
});

document.addEventListener('teeinblue-event-after-cart-added',async  function() {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  let sectionsToRender = cart.getSectionsToRender().map((section) => section.id).join(',');
  const sections = await fetch(`?sections=${sectionsToRender}`).then(response => response.json());
  let cartContent = await fetch(`${Shopify.routes.root}cart.js`).then(response => response.json());
  
  if (!cart || !sections || !cartContent) {
    return;
  }
  
  cartContent = {
    ...cartContent,
    key: cartContent.items?.at(0)?.key ?? '',
    sections: sections,
  };
  
  cart.renderContents(cartContent);
  if (cartContent.items.length === 0) {
    cart.classList.add('is-empty');
  }
});

document.addEventListener('teeinblue-event-component-injected', () => {
  moveElementAfter('.tee-product-price', '.tee-customize-main-form');
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};